import type { TableColumns } from '@faceup/ui-base'

export const mockCredentialTableColumns: TableColumns<(typeof fuAdminsMock)[number]> = [
  {
    title: 'Email',
    dataIndex: 'email',
  },
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Role',
    dataIndex: 'role',
  },
]

export const fuAdminsMock = [
  {
    email: 'multiple@faceup.com',
    name: 'MULTIPLE',
    role: 'Manager',
  },
  {
    email: 'southafrica@faceup.com',
    name: 'South Africa',
    role: 'Admin',
  },
  {
    email: 'superadmin@faceup.com',
    name: 'SuperAdmin',
    role: 'Admin',
  },
  {
    email: 'faceup@scio.cz',
    name: 'SCIO',
    role: 'Manager',
  },
  {
    email: 'psycholog@faceup.com',
    name: 'PSYCHOLOGIST',
    role: 'Psychologist',
  },
  {
    email: 'unitedstates@faceup.com',
    name: 'United States',
    role: 'Admin',
  },
  {
    email: 'czechia@faceup.com',
    name: 'Václav Klaus',
    role: 'Admin',
  },
]
